<template>
  <div>
    <LayoutBanner
      activeNav="比赛评选"
      :topColor="topColor"
      bannerType="header match"
      :height="250"
    />
    <div class="container">
      <section class="nav">
        <ul>
          <li
            :class="nav_item.name === matchClass.name ? 'activeNav' : ''"
            v-for="(nav_item, nav_index) in navList"
            :key="nav_index"
            @click="changeActive(nav_item)"
          >
            {{ nav_item.name }}
          </li>
        </ul>
      </section>
      <section class="matchs">
        <div class="matchs_container">
          <ul v-if="matchList.length!==0">
            <li
              v-for="(match_item, match_index) in matchList"
              :key="match_index"
              @click="toWorks(match_item)"
            >
              <img
                v-if="match_item.img_main_full"
                :src="match_item.img_main_full"
                alt=""
              />
              <img
                v-else
                src="../../assets/images/match/PJ-BS-fenmian-normol.png"
                alt=""
              />
              <div class="info">
                <div class="text">
                  <h1>{{ match_item.name }}
                    -{{ match_item.group_name }}
                    </h1>
                  <span
                    >{{ match_item.date_start_show }}——{{
                      match_item.date_end_show
                    }}</span
                  >
                </div>
                <div
                  v-if="match_item.contest_time.now_status !== null"
                  class="time"
                >
                  {{ match_item.contest_time.now_status.name }}中
                </div>
                <div class="time" v-else-if="match_item.leftTime">
                  距离结束还有{{ match_item.leftTime }}
                </div>
                <div class="time" v-else>已结束</div>
              </div>
            </li>
          </ul>

           <LayoutNoData background='white' v-else />
        </div>
      </section>
      <section class="paging">
        <LayoutPaging
          :total="total"
          @handleChange="changePage"
          style="background-color: #f2f2f2; padding-bottom: 56px"
        />
      </section>
    </div>
    <LayoutFooter />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import SystemServices from "../../xx-vue/services/system";
import Storage from "../../xx-vue/utils/storage";
const { mapState, mapMutations, mapActions } = createNamespacedHelpers("Match");
export default {
  data() {
    return {
      topColor: "",
      navList: [{ name: "推荐" }, { name: "最新" }],
    };
  },
  computed: {
    ...mapState(["matchList", "total", "page", "matchClass"]),
  },
  mounted() {
    this.initScroll();
    const userInfo = Storage.getStorage("info");
    if (userInfo) {
      if (
        userInfo.expert_info.status_apply !== undefined &&
        userInfo.expert_info.status_apply == 1
      ) {
        this.navList[2] = { name: "我的评审" };
      } else {
        this.navList[2] = { name: "我的参赛" };
      }
    }
    this.getMatchList();
    this.initData();

    let jumpReview = this.$route.query.jumpReview;
    if (jumpReview == "true") {
      this.changeClass({ name: "我的评审" });
    }
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.listenerFunction);
  },
  watch: {
    page() {
      this.getMatchList();
    },
    matchClass() {
      this.getMatchList();
    },
  },
  methods: {
    ...mapActions(["getMatchList"]),
    ...mapMutations(["changePage", "changeClass"]),
    //初始化滚动条监听
    initScroll() {
      document.addEventListener("scroll", this.handleScroll, true);
    },
    //监听滚动条移动
    handleScroll() {
      const pageY = window.pageYOffset;
      if (pageY === 0) {
        this.topColor = "background-color: rgba(0, 0, 0, 0.3)";
      } else {
        this.topColor = "background-color: rgb(22,22,22)";
      }
    },
    //更改激活Nav
    changeActive(val) {
      this.changeClass(val);
    },
    //跳转作品
    toWorks(item) {
      this.$router.push(
        `/match/match_works?project_id=${~~item.id}&group_id=${~~item.group_id}`
      );
    },
    //获取行业类型
    async initData() {
      const result = await SystemServices.getIndustryAsync();
      const nav = result.data.data.map((v) => {
        return { name: v.name, id: v.id };
      });
      this.navList = [...this.navList, ...nav];
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  .nav {
    box-shadow: 0px 4px 8px #c7c7c7;
    position: relative;
    ul {
      width: 1400px;
      margin: 0 auto;
      li {
        min-width: 112px;
        margin-left: 68px;
        display: inline-block;
        font-size: 18px;
        text-align: center;
        color: #333333;
        cursor: pointer;
        padding: 20px;
      }

      .activeNav {
        color: #f2252f;
        font-weight: bold;
        border-bottom: 2px solid #e24141;
      }
    }
  }
  .matchs {
    background-color: #f2f2f2;
    .matchs_container {
      padding: 48px 0;
      width: 1200px;
      margin: 0 auto;
      ul {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        li {
          width: 48%;
          font-size: 0;
          margin-bottom: 42px;
          cursor: pointer;
          & > img {
            width: 100%;
            height: 280px;
          }

          .info {
            display: flex;
            justify-content: space-between;
            align-items: center;
            background-color: white;
            padding: 23px 0 23px 20px;

            .text {
              h1 {
                font-size: 16px;
                font-weight: normal;
                color: #333333;
              }

              span {
                color: #989898;
                font-size: 12px;
              }
            }

            .time {
              color: #a77272;
              padding: 5px 20px 5px 32px;
              font-size: 16px;
              background: url("../../assets/images/match/bs-bg-time1@2x.png")
                no-repeat;
              background-size: 100% 100%;
            }

            .reviewing {
              color: #a77272;
              padding: 5px 20px 5px 32px;
              font-size: 16px;
              background: url("../../assets/images/match/bs-bg-time2@2x.png")
                no-repeat;
              background-size: 100% 100%;
            }
          }
        }
      }
    }
  }
}
</style>